import angular from 'angular'

/**
 * Filter for getting the name of a User.
 *
 * @module webregister.filters.wrUserName
 */
angular.module('webregister.filters').filter('wrUserName', function () {
  /**
   * Get the name to display for the given user. Will fall back on the user's username if there is no
   * display name.
   *
   * @method wrUserName
   *
   * @param  {User} user
   *         The user to get the name of
   *
   * @return {String} The name or username of the given user
   */
  return function wrUserName(user: $TSFixMe) {
    if (user) {
      return user.display_name || user.username
    } else {
      return ''
    }
  }
})
